import React from 'react';
import { Outlet, Routes, Route } from 'react-router-dom';

import WebhookPreview from '../components/settings/third-party/WebhookPreview';
import WebhookUpdate from '../components/settings/third-party/WebhookUpdate';
import WebhookList from '../components/settings/third-party/WebhookList';

import IndiaMartPreview from '../components/settings/third-party/IndiaMartPreview';
import IndiaMartUpdate from '../components/settings/third-party/IndiaMartUpdate';
import IndiaMartList from '../components/settings/third-party/IndiaMartList';

import OzonetelPreview from '../components/settings/third-party/OzonetelPreview';
import OzonetelUpdate from '../components/settings/third-party/OzonetelUpdate';
import OzonetelList from '../components/settings/third-party/OzonetelList';

import TataTelePreview from '../components/settings/third-party/TataTelePreview';
import TataTeleUpdate from '../components/settings/third-party/TataTeleUpdate';
import TataTeleList from '../components/settings/third-party/TataTeleList';

import Acres99Preview from '../components/settings/third-party/99AcresPreview';
import Acres99Update from '../components/settings/third-party/99AcresUpdate';
import Acres99List from '../components/settings/third-party/99AcresList';

import RealestateIndiaPreview from '../components/settings/third-party/RealestateIndiaPreview';
import RealestateIndiaUpdate from '../components/settings/third-party/RealestateIndiaUpdate';
import RealestateIndiaList from '../components/settings/third-party/RealestateIndiaList';

import MagicBrickPreview from '../components/settings/third-party/MagicBrickPreview';
import MagicBrickUpdate from '../components/settings/third-party/MagicBrickUpdate';
import MagicBricksList from '../components/settings/third-party/MagicbricksList';

import HousingPreview from '../components/settings/third-party/HousingPreview';
import HousingUpdate from '../components/settings/third-party/HousingUpdate';
import HousingList from '../components/settings/third-party/HousingList';

import McubePreview from '../components/settings/third-party/McubePreview';
import McubeUpdate from '../components/settings/third-party/McubeUpdate';
import McubeList from '../components/settings/third-party/McubeList';

import FacebookPreview from '../components/settings/third-party/FacebookPreview';
import FacebookUpdate from '../components/settings/third-party/FacebookUpdate';
import FacebookList from '../components/settings/third-party/facebook-integration/index';
import FacebookMapping from '../components/settings/third-party/facebook-integration/components/FacebookMapping';
import FacebookBackfill from '../components/settings/third-party/facebook-integration/components/FacebookBackfill';

import WhatsAppUpdate from '../components/settings/third-party/WhatsAppUpdate';
import WhatsAppList from '../components/settings/third-party/WhatsAppList';

import ThirdPartyList from '../components/settings/third-party/ThirdPartyList';

import withRouter from '../util/WithRouter';
import FacebookLeads from '../components/facebook/FacebookLeads';

class ThirdPartyRoute extends React.Component {

  render() {
    return (
      <Routes element={<Outlet />}>
        <Route path="/webhooks/preview/:id" element={<WebhookPreview />} />
        <Route path="/webhooks/add-edit/:id" element={<WebhookUpdate />} />
        <Route path="/webhooks" element={<WebhookList />} />

        <Route path="india-mart/preview/:id" element={<IndiaMartPreview />} />
        <Route path="india-mart/add-edit/:id" element={<IndiaMartUpdate />} />
        <Route path="india-mart" element={<IndiaMartList />} />

        <Route path="ozonetel/preview/:id" element={<OzonetelPreview />} />
        <Route path="ozonetel/add-edit/:id" element={<OzonetelUpdate />} />
        <Route path="ozonetel" element={<OzonetelList />} />

        <Route path="tatatele/preview/:id" element={<TataTelePreview />} />
        <Route path="tatatele/add-edit/:id" element={<TataTeleUpdate />} />
        <Route path="tatatele" element={<TataTeleList />} />

        <Route path="99acres/preview/:id" element={<Acres99Preview />} />
        <Route path="99acres/add-edit/:id" element={<Acres99Update />} />
        <Route path="99acres" element={<Acres99List />} />

        <Route path="realestate-india/preview/:id" element={<RealestateIndiaPreview />} />
        <Route path="realestate-india/add-edit/:id" element={<RealestateIndiaUpdate />} />
        <Route path="realestate-india" element={<RealestateIndiaList />} />

        <Route path="magicbricks/preview/:id" element={<MagicBrickPreview />} />
        <Route path="magicbricks/add-edit/:id" element={<MagicBrickUpdate />} />
        <Route path="magicbricks" element={<MagicBricksList />} />

        <Route path="housing/preview/:id" element={<HousingPreview />} />
        <Route path="housing/add-edit/:id" element={<HousingUpdate />} />
        <Route path="housing" element={<HousingList />} />

        <Route path="mcube/preview/:id" element={<McubePreview />} />
        <Route path="mcube/add-edit/:id" element={<McubeUpdate />} />
        <Route path="mcube" element={<McubeList />} />

        {/* TODO: Need to cheeck what these routes are, they might be not in use, so remove them in such case!!  */}
        <Route path="facebook/preview/:id" element={<FacebookPreview />} />
        <Route path="facebook/add-edit/:id" element={<FacebookUpdate />} />
        {/* <Route path="facebook/leads" element={<FacebookLeads />} /> */}

        <Route path="facebook" element={<FacebookList />} />
        <Route path="/facebook/mapping/:id" element={<FacebookMapping />} />
        {/* <Route path="facebook/backfill/:mappingId" element={<FacebookBackfill />} /> */}

        <Route path="whats-app/add-edit/:id" element={<WhatsAppUpdate />} />
        <Route path="whats-app" element={<WhatsAppList />} />

        <Route path="/" element={<ThirdPartyList />} />
      </Routes>
    );
  }
}
export default withRouter(ThirdPartyRoute);